import { APP_NAME } from "@excalidraw/common";

import "./ExcalidrawLogo.scss";

import type { CSSProperties } from "react";

const LogoIcon = () => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="ExcalidrawLogo-icon"
    aria-hidden="true"
  >
    <rect
      x="8"
      y="8"
      width="24"
      height="24"
      rx="7"
      fill="var(--color-logo-surface)"
      stroke="currentColor"
      strokeWidth="3"
    />
    <path
      d="M16.5 16v16M18.5 24l9.5-8M18.5 24l9.5 8"
      stroke="currentColor"
      strokeWidth="3.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LogoText = () => <span className="ExcalidrawLogo-text">{APP_NAME}</span>;

type LogoSize = "xs" | "small" | "normal" | "large" | "custom" | "mobile";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: CSSProperties;
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
  withText,
}: LogoProps) => {
  return (
    <div className={`ExcalidrawLogo is-${size}`} style={style}>
      <LogoIcon />
      {withText && <LogoText />}
    </div>
  );
};
